import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectRectangleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 19.75C21.5859 19.75 21.25 20.0859 21.25 20.5V21.25H20.5C20.0859 21.25 19.75 21.5859 19.75 22C19.75 22.4141 20.0859 22.75 20.5 22.75H22C22.4141 22.75 22.75 22.4141 22.75 22V20.5C22.75 20.0859 22.4141 19.75 22 19.75Z"
        fill={color}
      />
      <path
        d="M17.0996 21.25H13.6992C13.2851 21.25 12.9492 21.5859 12.9492 22C12.9492 22.4141 13.2851 22.75 13.6992 22.75H17.0996C17.5137 22.75 17.8496 22.4141 17.8496 22C17.8496 21.5859 17.5137 21.25 17.0996 21.25Z"
        fill={color}
      />
      <path
        d="M10.2998 21.25H6.89941C6.48531 21.25 6.14941 21.5859 6.14941 22C6.14941 22.4141 6.48531 22.75 6.89941 22.75H10.2998C10.7139 22.75 11.0498 22.4141 11.0498 22C11.0498 21.5859 10.7139 21.25 10.2998 21.25Z"
        fill={color}
      />
      <path
        d="M3.5 21.25H2.75V20.5C2.75 20.0859 2.4141 19.75 2 19.75C1.5859 19.75 1.25 20.0859 1.25 20.5V22C1.25 22.4141 1.5859 22.75 2 22.75H3.5C3.9141 22.75 4.25 22.4141 4.25 22C4.25 21.5859 3.9141 21.25 3.5 21.25Z"
        fill={color}
      />
      <path
        d="M2 11.0498C2.4141 11.0498 2.75 10.7139 2.75 10.2998V6.89941C2.75 6.48531 2.4141 6.14941 2 6.14941C1.5859 6.14941 1.25 6.48531 1.25 6.89941V10.2998C1.25 10.7139 1.5859 11.0498 2 11.0498Z"
        fill={color}
      />
      <path
        d="M2 17.8496C2.4141 17.8496 2.75 17.5137 2.75 17.0996V13.6992C2.75 13.2851 2.4141 12.9492 2 12.9492C1.5859 12.9492 1.25 13.2851 1.25 13.6992V17.0996C1.25 17.5137 1.5859 17.8496 2 17.8496Z"
        fill={color}
      />
      <path
        d="M3.5 1.25H2C1.5859 1.25 1.25 1.5859 1.25 2V3.5C1.25 3.9141 1.5859 4.25 2 4.25C2.4141 4.25 2.75 3.9141 2.75 3.5V2.75H3.5C3.9141 2.75 4.25 2.4141 4.25 2C4.25 1.5859 3.9141 1.25 3.5 1.25Z"
        fill={color}
      />
      <path
        d="M17.0996 1.25H13.7002C13.2861 1.25 12.9502 1.5859 12.9502 2C12.9502 2.4141 13.2861 2.75 13.7002 2.75H17.0996C17.5137 2.75 17.8496 2.4141 17.8496 2C17.8496 1.5859 17.5137 1.25 17.0996 1.25Z"
        fill={color}
      />
      <path
        d="M10.2998 1.25H6.8999C6.4858 1.25 6.1499 1.5859 6.1499 2C6.1499 2.4141 6.4858 2.75 6.8999 2.75H10.2998C10.7139 2.75 11.0498 2.4141 11.0498 2C11.0498 1.5859 10.7139 1.25 10.2998 1.25Z"
        fill={color}
      />
      <path
        d="M22 1.25H20.5C20.0859 1.25 19.75 1.5859 19.75 2C19.75 2.4141 20.0859 2.75 20.5 2.75H21.25V3.5C21.25 3.9141 21.5859 4.25 22 4.25C22.4141 4.25 22.75 3.9141 22.75 3.5V2C22.75 1.5859 22.4141 1.25 22 1.25Z"
        fill={color}
      />
      <path
        d="M22 12.9502C21.5859 12.9502 21.25 13.2861 21.25 13.7002V17.0996C21.25 17.5137 21.5859 17.8496 22 17.8496C22.4141 17.8496 22.75 17.5137 22.75 17.0996V13.7002C22.75 13.2861 22.4141 12.9502 22 12.9502Z"
        fill={color}
      />
      <path
        d="M22 6.1499C21.5859 6.1499 21.25 6.4858 21.25 6.8999V10.2998C21.25 10.7139 21.5859 11.0498 22 11.0498C22.4141 11.0498 22.75 10.7139 22.75 10.2998V6.8999C22.75 6.4858 22.4141 6.1499 22 6.1499Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectRectangleIcon.displayName = 'SelectRectangleIcon';
